import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions, StatusBar, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native';
import * as RootNavigation from '../RootNavigation';

import { SearchBar } from "@rneui/themed";
const carouselRef = React.createRef(null);

const {width, height} = Dimensions.get('window')


  
export default class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
            list: [],
            search: '',
            searchResponse: '',  
            
            
        }

        
  
      }

      searchFilterFunction = text => {
        this.setState({
          search: '',
          searchResponse: '',
          list: [],
        }, () => {
          this.setState({
            search: text,
          });
        });


        //get search data from api
        //get data from api
        
        fetch('https://ios.breketefamily.com/searchMovie.php?term='+this.state.search)
        .then((response) => response.json())
        .then((responseJson) => {
           
         // console.log(responseJson)
          if(responseJson.status == 0){
          this.setState({
              list: responseJson.results,
             
            });
            console.log(this.state.list)
          }else{
            this.setState({
              searchResponse: 'No results found',
            });
          }

         
        }
        )
        .catch((error) => {
          hideLoader();
          console.error(error);
        }
        );
      };
      renderItem = (item) => {
        return(
          <TouchableOpacity style={{flex:1, flexDirection:'row', padding:10}} 
                onPress={() => {
                  RootNavigation.navigate('Player', {
                    movie: item
                  });
                }}>
            <Image style={{width:100, height:100, borderRadius:10}} source={{uri: item.image}}/>
            <View style={{flex:1, marginLeft:10}}>
              <Text style={{fontSize:20}}>{item.title}</Text>
            
            </View>
          </TouchableOpacity>
        )
      }
      renderFlatlist = () => {
     
     
        return(
          <FlatList
          data={this.state.list}
          renderItem={({item}) => this.renderItem(item)}
          keyExtractor={(item, index) => index.toString()}
          />
        )

      }
    

  

      componentDidMount() {
      
     // hideLoader();
      }

render(){

  return (
    <SafeAreaView>
  
      <AppLoader ref = { loaderRef } />


   
    <SearchBar
    placeholder="Search"
    onChangeText={text => this.searchFilterFunction(text)}
    value={this.state.search}
    />
    {this.state.searchResponse && <Text style={{textAlign:'center', fontSize:20, marginTop:10}}>{this.state.searchResponse}</Text>}
    {this.state.list.length > 0 && this.renderFlatlist()}

  
       
    </SafeAreaView>

  );
}
 

}

const styles = StyleSheet.create({


// CAROUSEL STYLES

carouselImage: {
    width: 200, 
    height: 320, 
    borderRadius: 10, 
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.9)'
},
carouselText: {
    paddingLeft: 14,
    color: 'white', 
    position: 'absolute', 
    bottom: 10, 
    left: 2, 
    fontWeight: 'bold'
},
carouselIcon: {
    position: 'absolute', 
    top: 15, 
    right: 15
},
carouselContentContainer: {
    flex: 1,
    backgroundColor: '#000',
    height: 720,
    paddingHorizontal: 14
  },
SearchboxContainer: {
    flexDirection: 'row',
    marginVertical: 20, 
    width: '95%',
    alignSelf: 'center', 
    backgroundColor: '#fff', 
    elevation: 10,
    borderRadius: 4,
  },
  Searchbox: {
    padding: 12,
    paddingLeft: 20,
    fontSize: 16,
  },
  SearchboxIcon: {
    position: 'absolute', 
    right: 20, 
    top: 14
  },
  ImageBg: {
    flex: 1,
    height: null,
    width: null,
    opacity: 1,
    justifyContent: 'flex-start',  
  },
  carouselContainerView: {
    width: '100%',
    height:350 ,
    justifyContent: 'center',
    alignItems: 'center',
},
  carousel: {
    flex:1,
    overflow: 'visible',
} ,
movieInfoContainer: {
  flexDirection: 'row', 
  marginTop: 16, 
  justifyContent: 'space-between', 
  width: Dimensions.get('window').width - 14
},
movieName: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 20,
  marginBottom: 6
},
movieStat: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 14, 
  opacity: 0.8
},
playIconContainer: {
  backgroundColor: '#212121',
  padding: 18,
  borderRadius: 40,
  justifyContent: 'center',
  alignItems: 'center',
  elevation: 25,
  borderWidth: 4,
  borderColor: 'rgba(2, 173, 148, 0.2)',
  marginBottom: 14
}
});
